import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStudioDisplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStudioDisplay"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V18H16V21H8V18H2V4ZM10 18V19H14V18H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStudioDisplay;
